import React, { Component } from 'react';
import { Col, NavLink, Form, FormGroup, Input, Button, Row, Table, Label,Popover, PopoverBody  } from 'reactstrap';
import { getEMIBankAndOptionsList } from 'actions/payment';
import { DisplayPayBtnText, GoBack } from 'components/Common';
import { connect } from 'react-redux';
import { findObj } from 'lib/fp-utility';
import EMIGetCard from 'components/FDModal/emi-get-card';
import GlobalLoaderModal from "components/FDModal/global-loader";
import GlobalErrorModal from "components/FDModal/global-error";
import FPConfig from 'lib/config';

class EmiWidget extends Component {

	state = { showEMICardModal: false, loader: true, apiError: false,emiType:"1" }
	toggleEMICardModal = this.toggleEMICardModal.bind(this)
	handleBankChange = this.handleBankChange.bind(this)
	changeEMIOption = this.changeEMIOption.bind(this)
	openTermsUrl = this.openTermsUrl.bind(this)
	hideTermsPop = this.hideTermsPop.bind(this)
	toggleTermsPop = this.toggleTermsPop.bind(this)
	changeEmiType = this.changeEmiType.bind(this)
	cardSegregation = FPConfig.emiConfig.cardSegregation;
	toggleEMICardModal() {
		this.hideTermsPop()
		this.setState({ showEMICardModal: !this.state.showEMICardModal });
	}
	
	componentDidMount(e){
		getEMIBankAndOptionsList().then((resp)=>{
			// console.log("EMI Resp: ", resp)
			if(resp.response && resp.response.emibank){
				this.setState({emiBanks: resp.response.emibank, loader: false, apiError: false})
			}else{
				this.setState({emiBanks: [], apiError: true})
			}
		})
	}

	handleBankChange(e){
		this.setState({ selectedEmiBank: '', emiBankOptions: '', selectedEMIOption: '', termsAndConditionsUrl: false, terms: false});
		if(!e.target.value)
			return true 
	
		const bankObj = findObj(this.state.emiBanks, e.target.value, 'bankcode')
		console.log("BankCoDe",bankObj)
		this.setState({ selectedEmiBank: bankObj });
		getEMIBankAndOptionsList(bankObj).then((resp)=>{
			const { currency, termsAndConditionsUrl, emiTenureDetails} = resp.response
			this.setState({emiCurrency: currency, termsAndConditionsUrl})
			if(emiTenureDetails){
				this.setState({emiBankOptions: emiTenureDetails})
			}else{
				this.setState({emiBankOptions: ''})
			}
		})
	}
	
	changeEMIOption(emiOption){
		const bankObj = findObj(this.state.emiBankOptions, emiOption, 'emitenure')
        this.setState({selectedEMIOption: bankObj})
	}

	toggleTermsPop(){
		this.setState({ terms: !this.state.terms });
    } 
    
    hideTermsPop(){
		this.setState({ terms: false });
    } 
	
	openTermsUrl(){
		this.hideTermsPop()
		window.open(this.state.termsAndConditionsUrl, '_blank')
	}
	changeEmiType (event){
		this.setState({emiType: event.target.value,emiBankOptions: '',selectedEmiBank: ''})
	}

	render() {
		const { t } = this.props
		let withCurrency = {...this.state.selectedEMIOption, emiCurrency: this.state.emiCurrency }
		const {emiType} = this.state;
		const {cardSegregation} = this;	
		return(
			<React.Fragment>
			<Col xs="12">
				<div className="card-details-panel d-flex justify-content-center">
					<Form>
						{cardSegregation && <Row className="mb-3">
							<Col xs="6" >
							<input type="radio" value="1" name="emiType" id="creditCardType" className="form-check-input mr-3" 
										  defaultChecked={emiType === "1"} onClick={(e) => this.changeEmiType(e) }
										   />
							<Label for={`creditCardType`}>
									{t('CREDITCARD')}
							</Label>
							</Col>
							<Col xs="6" >
							<input type="radio" value="2" name="emiType" id="debitCardType" className="form-check-input" 
										   defaultChecked={emiType === "2"} onClick={(e) => this.changeEmiType(e) } 
										/>
								<Label for={`debitCardType`}>
									{t('DEBITCARD')}
								 </Label>
							</Col>
						</Row> } 
						<FormGroup >
							<div className="custom-dd">
							{cardSegregation &&  <Input type="select" name="select" value={this.state.selectedEmiBank && this.state.selectedEmiBank.bankcode} onChange={(e) => this.handleBankChange(e)}>
								<option value=''>---Select Bank---</option>
									{ 
										this.state.emiBanks && this.state.emiBanks.map((el, i) => {
											if(el.emitype == emiType){
												return <option key={el.bankcode} value={el.bankcode}>{el.bankname}</option>
											}else{
												return null
											}
										})
									} 
								</Input> }
								{! cardSegregation &&  <Input type="select" name="select" value={this.state.selectedEmiBank && this.state.selectedEmiBank.bankcode} onChange={(e) => this.handleBankChange(e)}>
								<option value=''>---Select Bank---</option>
									{ 
										this.state.emiBanks && this.state.emiBanks.map((el, i) => {
											return <option key={el.bankcode} value={el.bankcode}>{el.bankname}</option>
										})
									} 
								</Input> }
							</div>					
						</FormGroup>

						<div className="custom-tableCal">
							{
								this.state.emiBankOptions &&
								<Table cellSpacing="0" cellPadding="0">
									<thead>
										<tr>
											<th scope="col">{t('EMI Plan')}</th>
											{/* <th scope="col">{t('Installment')}*</th> */}
											<th scope="col">{t('Interest(pa)')}</th>
											<th scope="col">{t('Total Amount Payable')}</th>
										</tr>
									</thead>
									<tbody>
										{
											this.state.emiBankOptions.map((bankOption,i)=> {
												return (
													<tr key={i} className={this.state.selectedEMIOption.emitenure===bankOption.emitenure ? 'activeTable' : ''}>
														<td>
															<div className="d-flex">
																<Input id={`test${i}`} name="radio-group" type="radio" value={bankOption.emitenure} className="form-check-input" onClick={() => this.changeEMIOption(bankOption.emitenure)} defaultChecked={this.state.selectedEMIOption===bankOption.emitenure}/>
																<Label for={`test${i}`}></Label>
																{t(this.state.emiCurrency)}  {bankOption.emipermonth} x&nbsp;
																{bankOption.emitenure}{t('M')} 
															</div>
														</td>
														{/* <td data-label="Install">{t(this.state.emiCurrency)}  {bankOption.emipermonth}</td> */}
														<td data-label="Interest(pa)">{bankOption.emiintrate}&#37;</td>
														<td data-label="Total Amount Payable">
														{t(this.state.emiCurrency)} {bankOption.emitotalamt}</td>
													</tr>
												)
											})
										}
									</tbody>
								</Table>
							}
						</div>
						
						<Button disabled={!this.state.selectedEMIOption || this.state.loader || !this.props.termsStatus} onClick={() => this.toggleEMICardModal()} className="btn mt-2">
							<DisplayPayBtnText 
								selectedEMIOption={withCurrency}
								transactionDetails={this.props.transactionDetails} t={t} />
						</Button>

						<div className="go-back-site">
							<Row>
								<Col className="mob-text-mid" xs="12" md="6">
									{
										this.state.termsAndConditionsUrl && 
										<>
											<NavLink><span onClick={this.toggleTermsPop} className="icon-info" id="terms-popover"></span> {t('Terms and Conditions')}</NavLink>
											<Popover placement="top" isOpen={this.state.terms}  target={'terms-popover'}>
												<PopoverBody>
													<p className="textGray-12 mb-2"><strong>{t('Note')}:</strong> {t('emi_order_note')}</p>
													<p className="textGray-12">*{t('installment_amount')} <NavLink onClick={this.openTermsUrl}>{t('click_for_banks')}</NavLink></p>
												</PopoverBody>
											</Popover>
										</>
									}
								</Col>
								<Col className="mob-text-mid text-center" xs="12" md="12">
									<GoBack t={t} />
								</Col>
							</Row>
						</div>
						{t('emi_option', {returnObjects: true}).map(({option}, i) => (
                            <p key={i} className="text-14 mb-3">{option}</p>
                        ))}
					</Form>
				</div>
			</Col>
			{ this.state.loader &&  <GlobalLoaderModal /> }
			{this.state.apiError && <GlobalErrorModal />}

			{ this.state.showEMICardModal && <EMIGetCard 
			toggleEMICardModal={this.toggleEMICardModal} 
			modalClassName="custom-emi-popup" 
			selectedEmiBank={this.state.selectedEmiBank} 
			emiCurrency={this.state.emiCurrency}
			selectedEMIOption={withCurrency} 
			savedCards={this.props.savedCards} 
			t={t} 
			emiCardType = {emiType == "1"?"CC":"DC"}
			termsAndConditionsUrl={this.state.termsAndConditionsUrl}/> }
			</React.Fragment>
			
		);
	}
}


const mapStateToProps = state => {
    const {termsStatus, savedCards, transactionDetails, txnKey, txnIv } = state.fdData
    let returnProps = {termsStatus, savedCards, transactionDetails, txnKey, txnIv }
    return { ...returnProps }
}

export default connect(mapStateToProps, { })(EmiWidget);